import { render, staticRenderFns } from "./appoinmentTypeList.vue?vue&type=template&id=133c6bc9&"
import script from "./appoinmentTypeList.vue?vue&type=script&lang=js&"
export * from "./appoinmentTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports